import { useFeatureFlag } from '@modules/feature-flag';

import { type GetCardUrlOptions, getQrCardUrl } from './card-urls';

export { Subdomain } from './card-urls';

/** Return type for QR code URL hooks */
type QRCodeUrlHook = {
  /** Function to generate QR code URLs */
  getQrCardUrl: (cardId?: string, options?: GetCardUrlOptions) => string;
  /** Whether the feature flag is still loading */
  loading: boolean;
};

/**
 * Hook that provides QR code URL generation with feature flag support.
 * Uses the 'qr_link_subdomains' feature flag to determine the appropriate
 * subdomain variant for QR code URLs.
 * @returns Object containing the QR URL generator function and loading state
 */
export function useGetQRCodeUrl(): QRCodeUrlHook {
  const [qrVariant, { loading }] = useFeatureFlag('qr_link_subdomains', 'share');

  return {
    getQrCardUrl: (cardId, options) => getQrCardUrl(cardId, { ...options, qrVariant }),
    loading,
  };
}
